<template>
  <div  >
   <van-cell-group class="body kuang">
      <van-cell
        v-if="list.province"
        title="地区"
        :value="`${list.province || ''}${list.city || ''}${list.district || ''}`"
      />
      <van-cell
        v-if="list.redScarfMedal"
        title="今年内是否开展“红领巾奖章”评定颁发？"
        :value="format(list.redScarfMedal, 1)"
      />
      <div v-if="list.redScarfMedal == 1">
        <van-cell v-if="list.twoStar" title="二星章" :value="format(list.twoStar, 1)" />
        <van-cell
          v-if="list.twoOrThreeStar"
          title="二星章或三星章"
          :value="format(list.twoOrThreeStar, 1)"
        />
        <van-cell v-if="list.threeStar" title="三星章" :value="format(list.threeStar, 1)" />
        <van-cell v-if="list.fourStar" title="四星章" :value="format(list.fourStar, 1)" />
      </div>
    </van-cell-group>
  </div>
</template>
<script>
import { format } from "@/common/js/utils";
export default {
  props: {
    list: Object,
  },
  setup() {
    return { format };
  },
};
</script>
<style lang="less" scoped>
.body {
  margin-bottom: 1.53333rem;
}
</style>
